import React from 'react';
import { loadCategories } from './Helper';
import { BasicDataTable } from '../../components/DataTable';
import { ErrorToastComponent as ErrorToast  } from '../../components/Toasts';

class CategoryListPage extends React.Component {
    constructor(props) {
        super();
        this.state = {
            datatable: {
                columns: [
                    {
                        label: 'Name',
                        field: 'category_name'
                    },
                    {
                        label: 'Type',
                        field: 'entity_type',
                        width: 150
                    },
                    {
                        label: 'Action',
                        field: 'product_action'
                    }
                ],
                rows: []
            }
        }
    }

    async componentDidMount() {
        try {

            // load sites
            await this.loadAvailableItems(this.props.owner);

        } catch(err) {
            throw new Error(err.message);
        }
    }

    async loadAvailableItems(owner) {
        try {

            const self = this;
            const categories = await loadCategories(owner);

            const productRows = [];
            for(const itemInfo of categories) {
                if(itemInfo.category) {
                    const product = {
                        category_name: itemInfo.category.category_name,
                        entity_type: itemInfo.category.entity_type,
                        product_action: self.itemActions(itemInfo.category.category_id)
                    };
                    productRows.push(product);
                }
            }
        
            self.setState({
                datatable: {
                    columns: self.state.datatable.columns,
                    rows: productRows
                }
            });

        } catch(err) {
            throw new Error(err.message);
        }
    }

    getCompleteAddress(addresses) {
        try {
            const stringBuffer = [];
            for(const addrKey in addresses) {
                const addrValue = addresses[addrKey];
                stringBuffer.push(addrValue);
            }
            return stringBuffer.join(", ");
        } catch(err) {
            return 'Error in address'
        }
    }

    redirectItemPage(categoryID) {
        try {
            const path = `/inventory?screen=dashboard&warehouse_id=${categoryID}`;
            window.location.href = path;
            return;
        } catch(err) {
            throw new Error(err.message);
        }
    }

    itemActions(categoryID) {
        try {
            return (
                <>
                    <button className="btn btn-info btn-circle btn-sm" data-toggle="tooltip" title='Check Category Information' onClick={() => this.redirectItemPage(categoryID)}>
                        <i className="fas fa-info-circle"></i>
                    </button>
                </>
            );
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async createNewCategory() {
        try {
            window.location.href = '/inventory?screen=addcategory';
            return;
        } catch(err) {
            throw new Error(err.message);
        }
    }

    addProductButton() {
        try {
            return (
                <button className="btn btn-success btn-circle btn-sm add-token-btn" data-toggle="tooltip" title='Create new category' onClick={this.createNewCategory}>
                    <i className="far fa-plus-square"></i>
                </button>
            )
        } catch(err) {
            throw new Error(err.message);
        }
    }

    renderTable() {
        try {
            let table = 'No items available';
            if(this.state.datatable.rows.length > 0) {
                table = <BasicDataTable label='Available Categories' data={this.state.datatable} />;
            }

            return (
                
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">Available Categories</h6>
                        {this.addProductButton()}
                    </div>
                    <div className="card-body">
                        {table}
                    </div>
                </div>
            );
        } catch(err) {
            throw new Error(err.message);
        }
    }

    pageContent() {
        try {
            return (
                <>
                    {this.renderTable()}
                </>
            )
        } catch(err) {
            throw new Error(err.message);
        }
    }

    render() {
        return (
            <>  
                <div className='container'>
                    {this.pageContent()}
                    <ErrorToast message={this.state.err_message}/>
                </div>
            </>
        );
    }
}

export default CategoryListPage;